export function relativeDate(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    const diff = (d.getTime() - Date.now()) / 1000;
    const rtf = new Intl.RelativeTimeFormat("es-ES", { numeric: "auto" });
    const units = [
        ["year", 31536000],
        ["month", 2592000],
        ["week", 604800],
        ["day", 86400],
        ["hour", 3600],
        ["minute", 60],
    ];
    for (const [unit, secs] of units) {
        if (Math.abs(diff) >= secs || unit === "minute") {
            return rtf.format(Math.round(diff / secs), unit);
        }
    }
    return "ahora mismo";
}

export function formatDate(iso) {
    if (!iso) return "";
    return new Date(iso).toLocaleDateString("es-ES", { day: "2-digit", month: "long", year: "numeric" });
}

export function dayKey(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    const today = new Date();
    const y = new Date(today);
    y.setDate(today.getDate() - 1);
    if (d.toDateString() === today.toDateString()) return "Hoy";
    if (d.toDateString() === y.toDateString()) return "Ayer";
    return d.toLocaleDateString("es-ES", { day: "2-digit", month: "long", year: "numeric" });
}

const PALETTE = ["#a85641", "#5f7a6b", "#7a6a86", "#8a6d3b", "#4a6b82"];
export function initials(name) {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/);
    return (parts[0][0] + (parts[1] ? parts[1][0] : "")).toUpperCase();
}
export function avatarColor(seed) {
    let h = 0;
    for (let i = 0; i < (seed || "").length; i++) h = seed.charCodeAt(i) + ((h << 5) - h);
    return PALETTE[Math.abs(h) % PALETTE.length];
}
